import css from 'styled-jsx/css';
import { colors, typography } from '../../config/styles';
import { svgUrl } from '../../utils/staticUrls';

const ProductColorSwatchesStyles = css`
  .color-swatch-container {
    position: relative;
    display: flex;
  }

  .expandable-wrapper {
    display: flex;
    flex-direction: column;

    .expand-swatch {
      align-self: start;
      font-size: ${typography.sm};
      background: none;
      border: none;
      cursor: pointer;
      margin: 8px 0px;
      display: flex;
      align-items: center;

      &:hover {
        background-color: ${colors.gray.shade3};
      }
    }
  }

  .plus-icon {
    background-image: url(${svgUrl('plus.svg')});
    background-repeat: no-repeat;
    background-size: contain;
    height: 12px;
    width: 12px;
    margin-right: 6px;
    display: inline-block;
    vertical-align: middle;
  }

  .collapse-text {
    border-bottom: 1px solid #333333;
  }

  .mkp-color-swatch {
    margin-bottom: 17px;
  }

  .color-swatch-HARDLINE {
    width: 100%;
    @mixin tabletToDesktop {
      max-width: 305px;
    }

    &-collapse {
      display: block;
      max-height: 106px;
      @media (min-width: 768px) and (max-width: 1024px) {
        max-height: 106px;
      }
      @mixin desktop {
        max-height: 90px;
      }
      overflow: hidden;
      position: relative;
    }

    &-collapse-image {
      display: block;
      max-height: 124px;
      @mixin desktop {
        max-height: 140px;
      }
      overflow: hidden;
      position: relative;
    }

    @media (min-width: 768px) {
      &-collapse-image {
        max-height: 160px;
      }
    }
  }

  .color-swatch-SOFTLINE {
    width: 100%;

    &-collapse {
      max-height: 68px;
      @mixin desktop {
        max-height: 76px;
      }
      overflow: hidden;
      position: relative;
    }

    &-collapse-image {
      max-height: 132px;
      @mixin desktop {
        max-height: 140px;
      }
      overflow: hidden;
      position: relative;
    }
  }
`;

export { ProductColorSwatchesStyles };
